/**
 * @file routes/loader.ts
 * @description loader to resolve the routes based on the app edition
 *
 * @author ogarcia (ozkary)
 *
 */
import { getPpmRoutes } from './index';
import { getVscRoutes } from '../vsc/routes';
import { getRenewRoutes } from '../renew/routes';
import { isRenewal, isVsc } from '../services/settings';
import { memo, useEffect, useState } from 'react';
import { routeInfo } from './pageLoader';
import { Route, Routes } from 'react-router-dom';

// solves the selected edition routing component
// const EditionRouter = isRenewal ? renewRouter : isVsc ? vscRouter : ppmRouter;
// export default EditionRouter;

const Router = (): JSX.Element => {  
    const [pageRoutes, setPageRoutes] = useState([] as routeInfo[]);
  
    // initialize the route dependencies
    useEffect(() => {
      if (!pageRoutes || pageRoutes?.length < 1) {
        const getRoutes = isRenewal ? getRenewRoutes : isVsc ? getVscRoutes : getPpmRoutes;
        const list = getRoutes();
        setPageRoutes(list);      
      }    
    },[pageRoutes]);
  
    if (!pageRoutes || pageRoutes.length < 1) {
      return (<></>);
    }
  
    return (
      <Routes>
        {pageRoutes.map((routeItem) => (
          <Route
            key={routeItem.key}
            path={routeItem.path}
            element={
                <routeItem.elm />
            }
          />
        ))}
      </Routes>
    );
  };
  
  export default memo(Router);